(function ($) {
  var $ = (jQuery = $);

  var path = window.location.href;
  var sub_catorgey = "";
  var col_title = " ";
  var design_tag = "";
  var design_name = "";
  var get_components = [];
  var door_collections = "";
  var drawers_collections = "";
  var coverpanels_collection = "";
  var wood = "";
  var fillers_collection = "";
  var plinths_collection = "";
  var hardware_collection = "";
  var color_tag = "";
  var collection_tag = "";
  var collection_name = "";
  var collection_names = "";
  var product_tag = "";
  var beige_color = "";
  var grey_color = "";
  var green_color = "";
  var ivory_color = "";
  var black_color = "";
  var white_color = "";
  var latte_color = "";
  var dark_color = "";
  var natural_color = "";
  var light_blue_color = "";
  var light_green_color = "";
  var burgundy_color = "";
  var butter_color = "";
  var midnight_color = "";

  $("#hardware-collection").removeClass("inactive");
  $(".item-design").click(function () {
    $("#custom_search_result_wrapper .section-main-product").empty();
    $(".item-design").removeClass("selected");
    $(this).toggleClass("selected");
    sub_catorgey = $(this).data("sub_category");
    if(!sub_catorgey){
      console.log('false');
       clickEvent(this);
      $('.sub-category').addClass('hidden-section');
    }else{
      $('.sub-category').addClass('hidden-section');
     col_title = $(this).data('title');
      $('.'+ col_title).removeClass('hidden-section');
      $('.item-color').addClass('inactive');
      $('.item-collection').addClass('inactive');
      $('.item-color').removeClass('selected');
      $('.item-collection').removeClass('activecoll');
      $('.item-collection').removeClass('selected')
    }
   
  });

$('.item-design-sub_categroy').click(function(){
   $("#custom_search_result_wrapper .section-main-product").empty();
   $(".item-design-sub_categroy").removeClass("selected");
    $(this).toggleClass("selected");
   clickEvent(this);
})
  
  function clickEvent(event) {
    design_tag = $(event).data("design-url");
    design_name = $(event).data("design-name");

    door_collections = $(event).data("door-collection");
    drawers_collections = $(event).data("drawers-collection");
    wood_collection = $(event).data("wood-collection");
    coverpanels_collection = $(event).data("coverpanels-collection");
    fillers_collection = $(event).data("fillers-collection");
    plinths_collection = $(event).data("plinths-collection");
    hardware_collection = $(event).data("hardware-collection");

    console.log("check design issue", event);
    //console.log('door',door_collections,'drawers',drawers_collections);
    // console.log("coverpanels_collection:", coverpanels_collection);

    beige_color = $(event).data("beige-color");
    grey_color = $(event).data("grey-color");
    green_color = $(event).data("green-color");
    ivory_color = $(event).data("ivory-color");
    black_color = $(event).data("black-color");
    white_color = $(event).data("white-color");
    latte_color = $(event).data("latte-color");
    dark_color = $(event).data("dark-color");
    natural_color = $(event).data("natural-color");
    light_blue_color = $(event).data("light-blue");
    light_green_color = $(event).data("light-green");
    burgundy_color = $(event).data("burgundy-color");
    butter_color = $(event).data("butter-color");
    midnight_color = $(event).data("midnight-color");
    console.log("natural_color", natural_color);

    if ($(event).data("design-name") == "") {
      alert("Empty collection!");
    }

    $(".item-collection").removeClass("activecoll");
    $(".item-collection").addClass("inactive");
    $(".lpd-item.item-color").removeClass("activecoll");
    $(".lpd-item.item-color").addClass("inactive");

    if (door_collections == true) {
      let doorCollection = $("#door-collection").addClass("activecoll");
      $("#hardware-collection").removeClass("inactive");
      $("#door-collection").removeClass("inactive");
      $(".item-collection").removeClass("selected");
    }
    if (drawers_collections == true) {
      $("#drawers-collection").addClass("activecoll");
      $("#hardware-collection").removeClass("inactive");
      $("#drawers-collection").removeClass("inactive");
      $(".item-collection").removeClass("selected");
    }
    if (wood_collection == true) {
      $("#wood-collection").addClass("activecoll");
      $("#hardware-collection").removeClass("inactive");
      $("#wood-collection").removeClass("inactive");
      $(".item-collection").removeClass("selected");
    }
    if (coverpanels_collection == true) {
      $("#coverpanels-collection").addClass("activecoll");
      $("#hardware-collection").removeClass("inactive");
      $("#coverpanels-collection").removeClass("inactive");
      $(".item-collection").removeClass("selected");
    }
    if (fillers_collection == true) {
      $("#fillers-collection").addClass("activecoll");
      $("#hardware-collection").removeClass("inactive");
      $("#fillers-collection").removeClass("inactive");
      $(".item-collection").removeClass("selected");
    }
    if (plinths_collection == true) {
      $("#plinths-collection").addClass("activecoll");
      $("#hardware-collection").removeClass("inactive");
      $("#plinths-collection").removeClass("inactive");
      $(".item-collection").removeClass("selected");
    }
    if (hardware_collection == true || hardware_collection == true) {
      $("#hardware-collection").addClass("activecoll");
      $("#hardware-collection").removeClass("inactive");
      $(".item-collection").removeClass("selected");
    }

    if (beige_color == true) {
      $("#Beige").addClass("activecoll");
      $("#Beige").removeClass("inactive");
      $(".item-color").removeClass("selected");
    }
    if (grey_color == true) {
      $("#Grey").addClass("activecoll");
      $("#Grey").removeClass("inactive");
      $(".item-color").removeClass("selected");
    }
    if (green_color == true) {
      $("#Green").addClass("activecoll");
      $("#Green").removeClass("inactive");
      $(".item-color").removeClass("selected");
    }
    if (ivory_color == true) {
      $("#Ivory").addClass("activecoll");
      $("#Ivory").removeClass("inactive");
      $(".item-color").removeClass("selected");
    }
    if (black_color == true) {
      $("#Black").addClass("activecoll");
      $("#Black").removeClass("inactive");
      $(".item-color").removeClass("selected");
    }
    if (white_color == true) {
      $("#White").addClass("activecoll");
      $("#White").removeClass("inactive");
      $(".item-color").removeClass("selected");
    }
    if (latte_color == true) {
      $("#Latte").addClass("activecoll");
      $("#Latte").removeClass("inactive");
      $(".item-color").removeClass("selected");
    }
    if (dark_color == true) {
      $("#Dark").addClass("activecoll");
      $("#Dark").removeClass("inactive");
      $(".item-color").removeClass("selected");
    }
    if (natural_color == true) {
      console.log("condition true", natural_color);
      $("#Natural").addClass("activecoll");
      $("#Natural").removeClass("inactive");
      $(".item-color").removeClass("selected");
    }
    if (light_blue_color == true) {
      // console.log('light_blue_color 2', light_blue_color)
      $("#Light-Blue").addClass("activecoll");
      $("#Light-Blue").removeClass("inactive");
      $(".item-color").removeClass("selected");
    }
    if (light_green_color == true) {
      $("#Light-Green").addClass("activecoll");
      $("#Light-Green").removeClass("inactive");
      $(".item-color").removeClass("selected");
    }
    if (burgundy_color == true) {
      $("#Burgundy").addClass("activecoll");
      $("#Burgundy").removeClass("inactive");
      $(".item-color").removeClass("selected");
    }
    if (butter_color == true) {
      $("#Butter").addClass("activecoll");
      $("#Butter").removeClass("inactive");
      $(".item-color").removeClass("selected");
    }
    if (midnight_color == true) {
      $("#Midnight").addClass("activecoll");
      $("#Midnight").removeClass("inactive");
      $(".item-color").removeClass("selected");
    }
  }

  
  $(".item-color").click(function () {
    $("#custom_search_result_wrapper .section-main-product").empty();
    $(".item-color").removeClass("selected");
    $(this).toggleClass("selected");
    color_tag = $(this).data("color-name");
    //console.log("color_tag:", color_tag);
  });

  $(".item-collection").click(function () {
    $("#custom_search_result_wrapper .section-main-product").empty();
    $(".item-collection").removeClass("selected");
    $(this).toggleClass("selected");
    collection_tag = $(this).data("collection-url");
    collection_name = $(this).data("collection-name");
    // console.log("collection_name:", collection_name);
    //console.log("collection_tag:", collection_tag);
    if ($(this).data("collection-name") == "") {
      alert("Please add this block category collection first then search!");
    }
  });

  // $("#reset-btn").on("click",function(){
  //    window.location = path;
  // });

  $(".item-collection").click(function () {
    // $(".overlay-tpl").addClass("active-overlay");
    $("#custom_result_wrapper").empty();

    if (collection_tag == "HARDWARE") {
      var collection_url = "/collections/" + collection_tag;
      //console.log(collection_url);
      $.ajax({
        url: collection_url,
        dataType: "html",
        beforeSend: function () {
          $("#loading-image").show();
          // $("#reset-btn").show();
        },
        success: function (data) {
          $("#loading-image").hide();

          $("#custom_search_result_wrapper .section-main-product").html(
            $(data).find(".collection-template-main").html()
          );
          theme.Sections.register(
            "collection-template",
            theme.CollectionTemplateSection,
            { deferredLoad: false }
          );
          const Filter = $(data)
            .find(".collection-template-main .utility-bar")
            .hide();
          $(Filter).hide();
          //console.log('filter', Filter);
        },
      });

      var response_href = "";

      $(document).on("click", ".product-collection a", function (e) {
        e.preventDefault();
        response_href = $(this).attr("href");

        $.ajax({
          url: response_href,
          dataType: "html",
          success: function (data) {
            window.history.replaceState({}, "", path);
            window.location.hash = "#custom_result_wrapper";
            $("#custom_result_wrapper").html(
              $(data).find(".product-template").html()
            );
            globalFunctions.init();
            globalFunctions.productPageInitProductTabs();
          },
        });
      });
    } else {
      $.getJSON(
        "/collections/" + design_tag + "/products.json?limit=250",
        function (response) {
          console.log("dd", design_tag);
          Shopify.productOptionsMap = {};
          Shopify.quickViewOptionsMap = {};
          Shopify.optionsMap = {};

          console.log("products", response);

          var product_found = false;

          for (i = 0; i < response.products.length; i++) {
            //  console.log("collection name", collection_name);
            // console.log("color name", color_tag);
            //  console.log("product title", response.products[i].title);
            if (
              response.products[i].title.includes(color_tag + " ") &&
              response.products[i].tags.includes(collection_name) &&
              response.products[i].tags.includes("SOLP")
            ) {
              // console.log("product found ", response.products[i]);

              var handle = response.products[i].handle;

              var url = "/products/" + handle;

              product_found = true;

              break;
            }
          } // end of FOR loop

          if (product_found == false) {
            $("#custom_search_result_wrapper .section-main-product").html(
              "<h3 class='align-centre fully-spaced-row'>Sorry, No product found</h3>"
            );
          } else {
            $.ajax({
              url: url,
              dataType: "html",
              beforeSend: function () {
                $("#loading-image").show();
                // $("#reset-btn").show();
              },
              success: function (data) {
                $("#loading-image").hide();
                //$(data).find('.section-main-product .product-form').addClass('theme-init');
                var container = $(data)
                  .find(".product-template, .section-main-product")
                  .html();
                //var  maincontainerStore = $(data).find('.product-template, .section-main-product');
                var containerNew = container;

                //let variantPickerID = document.querySelector('variant-picker');
                //console.log("datadata",  variantPicker);
                //

                // var $formContainer = $(containerNew).find('.product-form');
                $("#custom_search_result_wrapper .section-main-product").html(
                  containerNew
                );
                //setFromVariantPicker();

                //var script=document.createElement('script');
                //script.type='text/javascript';
                //script.src="{{ 'main.js' | asset_url }}";
                //$('#custom_search_result_wrapper').append(script);

                //theme.Sections.register('main-product', theme.ProductTemplateSection, { deferredLoad: false });
              },
            });
          }
        }
      );
    }
  });
})(jQuery);
